import React from "react";
import type { CampaignQuestion } from "../types/CampaignQuestion";

interface QuestionInputProps {
  question: CampaignQuestion;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

const QuestionInput: React.FC<QuestionInputProps> = ({ question, value, onChange, error }) => {
  const baseClassName = "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500";
  const errorClassName = error ? "border-red-500" : "border-gray-300";

  const renderInput = () => {
    switch (question.type) {
      case 'textarea':
        return (
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`${baseClassName} ${errorClassName}`}
            rows={4}
            placeholder="Enter your answer..."
            required={question.is_required}
          />
        );
      case 'text':
      default:
        return (
          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`${baseClassName} ${errorClassName}`}
            placeholder="Enter your answer..."
            required={question.is_required}
          />
        );
    }
  };

  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {question.question}
        {question.is_required && <span className="text-red-500 ml-1">*</span>}
      </label>
      {renderInput()}
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default QuestionInput;
